import { Button, FlexBox, Skeleton, Text } from '@dixa/lib-shared-habla';
import { useHasAccess } from 'lib-shared-access-control';
import { ConversationAutomationBusinessHoursLogEntry } from 'lib-shared-types-api';
import { useCallback } from 'react';

import { flowsApi } from 'apis/flows';
import { useAppNavigate } from 'utils/url/useAppNavigate';

type RoutedThroughBusinessHoursProps = {
  node: ConversationAutomationBusinessHoursLogEntry;
};

export function RoutedThroughBusinessHours({
  node: { schedule_id: scheduleId },
}: RoutedThroughBusinessHoursProps): JSX.Element {
  const hasBusinessHoursAccess = useHasAccess('settings.business_hours');

  const navigate = useAppNavigate();

  const { isLoading, isFetching, isError, name } =
    flowsApi.useReadFlowScheduleQuery(
      {
        id: scheduleId,
      },
      {
        selectFromResult: ({ data, ...rest }) => {
          return {
            name: data?.name ?? '',
            ...rest,
          };
        },
        skip: !hasBusinessHoursAccess,
      },
    );

  const handleGoToBusinessHours = useCallback(() => {
    navigate({
      path: '/settings/businesshours/:id',
      params: {
        path: {
          id: scheduleId,
        },
      },
    });
  }, [scheduleId, navigate]);

  if (isLoading || isFetching) {
    return <Skeleton height="18px" width="200px" />;
  }

  if (isError && hasBusinessHoursAccess) {
    return (
      <FlexBox margin="300 0">
        <Button variant="secondary" onClick={handleGoToBusinessHours}>
          Go to business hours
        </Button>
      </FlexBox>
    );
  }

  return (
    <Text.Paragraph>
      {`Business hours · Automation visited business hours schedule ${
        hasBusinessHoursAccess ? name : ''
      }`}
    </Text.Paragraph>
  );
}
